import type { Maybe } from '@adornis/base/utilTypes.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import type { FormController } from '@adornis/forms/x-form-controller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import '@chancenwerk/components/chancen-component-student-data.js';
import type { CourseDigital } from '@chancenwerk/db/courses/CourseDigital.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-data-validation
 */
@customElement('anmeldung-component-formular-data-validation')
export class AnmeldungPageRegistrationDataValidation extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) student: Maybe<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;
  @property({ attribute: false }) digitalCoursesChoosen: CourseDigital[] = [];
  @property({ attribute: false }) schoolName = '';
  @property({ attribute: 'school-level' }) schoolLevel: 'us' | 'os' | 'graduation' = 'us';
  @property({ type: Boolean, attribute: 'hide-courses' }) hideCourses: boolean = false;

  override render() {
    return html`<cr-flex class="section-container" space="xl">
      <cr-flex class="sc-content">
        <cr-flex space="xl">
          <cr-h4 align="center">
            <b> Deine Daten </b>
          </cr-h4>
          <cr-text>
            ${this.schoolLevel === 'us'
              ? `Nachfolgend finden Sie eine Übersicht über die von Ihnen eingetragenen Daten. Bitte prüfen Sie, ob die
            Eingaben so korrekt sind. Falls Sie noch Änderungen vornehmen müssen, gelangen Sie mit Klick auf den Button
            "Zurück" auf die vorherigen Seiten.`
              : `Bitte überprüfe deine Daten und nutze den Zurück-Button, um ggf. Änderungen vorzunehmen.`}
          </cr-text>
          ${this.schoolLevel === 'graduation'
            ? html` <cr-text>
                Nachdem du deine Daten überprüft hast, übermittels du uns mit Klick auf "Absenden" die Anmeldung. Du
                erhältst bald eine Bestätigungsmail mit allen wesentlichen Informationen zu den nächsten Schritten.
                <b>
                  Bitte lies sie dir aufmerksam durch. Checke immer deinen E-Mail Account! Die Versendung der weiteren
                  Infos findet immer per E-Mail statt!
                </b>
              </cr-text>`
            : nothing}
          <chancen-component-student-data
            .student=${this.student}
            .digitalCoursesChoosen=${this.digitalCoursesChoosen}
            .schoolName=${this.schoolName}
            .hideCourses=${this.hideCourses}
            .hideAdditionalInfo=${this.schoolLevel === 'graduation'}
            hide-logos
            show-sensitive-data
          ></chancen-component-student-data>
          ${this.schoolLevel === 'us'
            ? html` <cr-text>
                Nachdem Sie Ihre Daten überprüft haben, übermitteln Sie uns mit Klick auf "Absenden" die Anmeldung für
                Ihr Kind. Sie erhalten eine Bestätigungsmail mit allen wesentlichen Informationen zu den nächsten
                Schritten. Bitte lesen Sie diese aufmerksam durch.
              </cr-text>`
            : nothing}
          <cr-button
            @click=${async () => {
              if (this.schoolLevel === 'us') {
                await XDialog.waitFor(this.form.validate());
              } else {
                this.form.validate().catch(console.error);
              }
            }}
          >
            ${this.translation.translate(this.schoolLevel === 'us' ? 'confirm' : 'next')}
          </cr-button>
        </cr-flex>
      </cr-flex>
    </cr-flex>`;
  }
}
